import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//状态管理
export default new Vuex.Store({
  state: { //唯一数据源，我理解为声明全局变量
    token: localStorage.getItem("token")||'',
    userinfor:JSON.parse(localStorage.getItem("userinfor"))||'',
  },
  getters: {//针对state数据的过滤，这里是get方法
    //获取token
    // getToken:state=>state.token
  },
  mutations: {//逻辑处理，但Mutation 必须是同步函数  这里是set方法
    //设置token
    setNewToken(state,newdata){
      state.token=newdata
    },
    //设置新用户信息
    setUserinfor(state,newdata){
      state.userinfor=newdata
    }
  },
  actions: {//Action 类似于 mutation,Action 提交的是 mutation，而不是直接变更状态;Action 可以包含任意异步操作.
    // setIncrement(context) {
    //   context.commit('increment')
    // }
  },
  modules: {

  }
});



// WEBPACK FOOTER //
// ./src/config/store.js